import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { GET_DISTRICT_DATA } from "../api/queries";
import { graphQLClient } from "../graphqlClient";
import type { District, GetDistrictDataResponse } from "../types/mmp-graphql";

interface QueryKey {
  id: string;
}

const fetchDistrictById = async ({
  queryKey,
}: {
  queryKey: [string, QueryKey];
}): Promise<District> => {
  const [, { id }] = queryKey;
  if (!id) throw new Error("District ID is required");

  const { getDistrictById } =
    await graphQLClient.request<GetDistrictDataResponse>(GET_DISTRICT_DATA, {
      id,
    });

  return getDistrictById;
};

export const useGetDistrictById = (
  id: string | undefined,
  enabled: boolean = true,
): UseQueryResult<District, Error> => {
  return useQuery({
    queryKey: ["districtById", { id: id || "" }],
    queryFn: fetchDistrictById,
    enabled: enabled && !!id,
  });
};
